import { FEEDS_ROUTES, NEEDLBOX_ROUTES } from '@/nav-routes';

export const getHelpCenterLink = (path: string): string => {
  if (path.includes(FEEDS_ROUTES.RSS_NEWS)) {
    return 'https://www.needl.ai/help/how-to-connect-website';
  } else if (path.includes(FEEDS_ROUTES.EXCHANGES)) {
    return 'https://www.needl.ai/help/how-to-connect-capital-markets';
  } else if (path.includes(FEEDS_ROUTES.WEBCLIPS)) {
    return 'https://www.needl.ai/help/add-to-needl-extension';
  } else if (path.includes(NEEDLBOX_ROUTES.BOOKMARKS_ALL)) {
    return 'https://www.needl.ai/help/how-to-use-tags-bookmarks';
  } else if (path.includes(NEEDLBOX_ROUTES.TAGS_ALL)) {
    return 'https://www.needl.ai/help/how-to-use-tags-bookmarks';
  }

  return 'https://www.needl.ai/help';
};
